<div class="container-select">
  <div class="search-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search and Select Company</mat-label>
      <input
        type="text"
        matInput
        [formControl]="searchControl"
        [matAutocomplete]="auto"
        placeholder="Type to search..."
      />

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (result of searchResults; track $index) {
        <mat-option [value]="result" (click)="onOptionSelected(result)">
          <div class="option-content">
            <span class="option-name">{{ result.company_name }}</span>
            @if (result.status) {
            <span class="option-description" [ngClass]="result.statusClass">
              Migration status: {{ result.status }}
            </span>
            }
          </div>
        </mat-option>
        } @if(showAll && filteredCount > 10) {
        <div class="show-all-container">
          <button
            mat-button
            class="show-all-button"
            (click)="onShowAllClick($event)"
          >
            <mat-icon>keyboard_double_arrow_down</mat-icon>{{ showAllText }}
          </button>
        </div>
        }
      </mat-autocomplete>

      @if (selectedValue && !isLoading) {
      <button
        mat-icon-button
        matSuffix
        (click)="clearSelection()"
        aria-label="Clear"
      >
        <mat-icon>close</mat-icon>
      </button>
      } @if (isLoading) {
      <mat-spinner
        matSuffix
        diameter="20"
        style="margin-right: 10px"
      ></mat-spinner>
      } @else if (!selectedValue) {
      <mat-icon matSuffix>search</mat-icon>
      } @if(selectedValue?.status){
      <mat-hint class="link" (click)="viewMigrationDetails()"
        >Migration {{ selectedValue?.migration_id }} status:
        <span [ngClass]="selectedValue?.statusClass">{{
          selectedValue?.status
        }}</span></mat-hint
      >
      } @if (searchControl.disabled && !isLoading && !loading) {
      <mat-hint class="mat-red-hint"
        >No companies available for search</mat-hint
      >
      }
    </mat-form-field>
  </div>
</div>
